import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const MainBase = (): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexFlow: 'column' }}>
      <Box sx={{ flex: '1 1 auto' }}>
        <Box
          sx={{
            padding: { xs: '16px', sm: '24px' },
            minHeight: '100%',
            background: (theme) => theme.palette.background.main,
          }}>
          <Box sx={{ width: { md: 512 }, maxWidth: 512, margin: '0 auto' }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MainBase;
